import Menu from '@spothero/icons/menu';
import Map from '@spothero/icons/map';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchPageView } from 'store/search/search-actions';
import { SearchPageView } from 'utils/search-page-view';
import { paramNameOptions, updateRouteParam } from 'utils/url-utils';
import StorageUtils from '@spothero/utils/storage';
import trackShowMobileSearchListView from 'segment/events/show-mobile-search-list-view';
import { useClearFocus } from 'pages/search/hooks/use-clear-focus';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
import { StorageKeys, StorageTypes } from 'common/constants/storageKeys';
import { OPTIMIZELY_FEATURE_ON, useFeatureVariation, } from 'plugins/optimizely/hooks/use-feature-variation';
export const useMobileViewToggle = () => {
    const { clearFocus } = useClearFocus();
    const dispatch = useDispatch();
    const searchPageView = useSelector((state) => state.search.data.view);
    const isAirport = useSelector((state) => state.searchRequest.airport);
    const showAirportMobileWebMap = useFeatureVariation(IMMEDIATE_FEATURES.AIRPORT_MOBILE_WEB_SHOW_MAP) ===
        OPTIMIZELY_FEATURE_ON;
    // Once a user manually switches to list view, stop forcing the map so
    // that choice sticks (even across the reload triggered below) instead of
    // permanently locking airport mobile web onto the map.
    const hasManuallySelectedListView = Boolean(StorageUtils.get(StorageKeys.AIRPORT_MOBILE_MAP_LIST_OVERRIDE, StorageTypes.SESSION));
    const pageView = isAirport && showAirportMobileWebMap && !hasManuallySelectedListView
        ? SearchPageView.MOBILE_MAP
        : searchPageView;
    useEffect(() => {
        if (pageView !== searchPageView) {
            dispatch(setSearchPageView({ view: pageView }));
        }
    }, [pageView, searchPageView, dispatch]);
    const handleClick = () => {
        // Clear focus to prevent incorrect visual state on mobile
        clearFocus();
        const newView = searchPageView === SearchPageView.MOBILE_LIST
            ? SearchPageView.MOBILE_MAP
            : SearchPageView.MOBILE_LIST;
        if (newView === SearchPageView.MOBILE_LIST) {
            // Invoking  dispatch(setSearchPageView({view: SearchPageView.MOBILE_LIST}))
            // causes a UI flicker as it will be followed by a reload.
            // Therefore, we avoid using it here.
            // Remember this choice so the forced airport map default (above)
            // doesn't override it back to MOBILE_MAP after the reload below.
            StorageUtils.set(StorageKeys.AIRPORT_MOBILE_MAP_LIST_OVERRIDE, true, StorageTypes.SESSION);
            // Update the URL with the new view
            updateRouteParam(paramNameOptions.VIEW, SearchPageView.MOBILE_LIST);
            // Track the Segment event
            trackShowMobileSearchListView();
            // When switching back to list view we do a full page reload
            // to show the original search results
            // Slack: https://spothero.slack.com/archives/C025ELN6L2G/p1704485541060059?thread_ts=1704482935.260369&cid=C025ELN6L2G
            return window.location.reload();
        }
        StorageUtils.remove(StorageKeys.AIRPORT_MOBILE_MAP_LIST_OVERRIDE, StorageTypes.SESSION);
        dispatch(setSearchPageView({
            view: newView,
        }));
    };
    const OptionList = {
        IconOption: Menu,
        label: 'List',
    };
    const OptionMap = {
        IconOption: Map,
        label: 'Map',
    };
    const activeOption = pageView === SearchPageView.MOBILE_LIST ? OptionMap : OptionList;
    return {
        handleClick,
        activeOption,
    };
};
